@import "~swagger-ui-dist/swagger-ui.css";

// WA: Swagger ui overrides - Mercury tokens
// Note: Using tokens directly instead of typography classes because SwaggerUI
// generates elements automatically and we don't have control over their classes
$fontFamily: var(--font-family-body, Inter, Helvetica, Arial, sans-serif);

// Override Swagger UI info paragraph color
.swagger-ui .info p,
.swagger-ui .info table {
  color: var(--color-text-neutral-disabled);
  font-family: var(--font-family-body, Inter, Helvetica, Arial, sans-serif);
}
$backgroundGray: var(--color-accent-surface-elevation-1);
$borderColor: var(--color-border-surface-on-surface);
$innerPadding: 12px;
$innerPaddingLarger: 16px;
$iconSize: var(--size-14, 14px);
$customGray: var(--color-text-neutral-disabled);

.swagger-ui {
  color: $customGray;
}

.swagger-ui .errors-wrapper {
  margin: 0 0 24px 0;
  padding: $innerPadding;
  border: 1px solid var(--color-text-error-default);
  border-radius: 0;
  animation: none;
}
.swagger-ui .errors-wrapper hgroup h4 {
  font-size: var(--font-size-body-s);
  font-family: $fontFamily;
}
.swagger-ui .errors-wrapper .errors h4 {
  font-size: var(--font-size-body-s);
  font-family: $fontFamily;
  margin-block-end: 8px;
}
.swagger-ui .errors-wrapper .error-wrapper {
  margin: 0 0 16px 0;
  font-size: var(--font-size-body-s);
}
.swagger-ui .errors-wrapper .error-wrapper:last-child {
  margin-block-end: 0;
}
.swagger-ui .errors-wrapper .errors small {
  font-size: var(--font-size-body-xs);
}
.swagger-ui {
  font-family: $fontFamily;
}
.swagger-ui .wrapper {
  padding: 0;
  margin-block-start: 8px;
  max-inline-size: 100%;
}
.swagger-ui .info {
  margin: 0;
}
.swagger-ui .servers-title {
  font-size: var(--font-size-body-s);
  font-weight: var(--font-style-semi-bold);
  line-height: var(--line-height-tight, 1.3);
  margin-block-end: 8px;
  display: inline-block;
}
.swagger-ui select {
  border: 1px solid $borderColor;
  box-shadow: none;
  border-radius: 0;
  font-weight: var(--font-style-regular);
  font-size: var(--font-size-body-s);
  background-color: var(--color-accent-surface-surface);
}
.swagger-ui .info .title {
  font-family: $fontFamily;
  font-size: var(--font-size-body-s);
  text-transform: uppercase;
  font-weight: var(--font-style-semi-bold);
  margin-block-end: 12px;
  color: $customGray;
}
.swagger-ui .info .title small {
  inset-block-start: 0;
  background-color: var(--color-accent-surface-elevation-1);
  vertical-align: baseline;
}
.swagger-ui .info .title small pre {
  color: var(--color-text-neutral-strawberry);
  font-family: $fontFamily;
  font-weight: var(--font-style-regular);
  font-size: var(--font-size-body-xs);
  font-style: italic;
}
.swagger-ui .info .title small.version-stamp pre {
  color: var(--color-text-neutral-on-text);
}
.swagger-ui .scheme-container {
  padding-block: 0;
  box-shadow: none;
  margin-block-end: 0;
  background-color: transparent;
}
.swagger-ui .opblock {
  margin: 0;
  border-color: $borderColor !important;
  background-color: transparent !important;
  border-radius: 4px;
  box-shadow: none;
}
.swagger-ui .opblock-tag {
  font-size: var(--font-size-body-s);
  font-weight: var(--font-style-semi-bold);
  margin-block-end: 0;
  padding: $innerPadding;
  color: $customGray;
}
.swagger-ui .opblock-tag {
  font-size: var(--font-size-body-s);
  font-weight: var(--font-style-semi-bold);
  margin-block-end: 0;
  padding: $innerPadding;
  color: $customGray;
}
.swagger-ui .opblock-tag-section.is-open .opblock-tag {
  border-bottom: 1px solid $borderColor;
}
.swagger-ui .opblock-tag-section {
  border: 1px solid $borderColor;
  margin-block-start: 24px;
  border-radius: 4px;
}
.swagger-ui .opblock .opblock-summary {
  padding: $innerPadding;
  cursor: default;
}
.operation-tag-content {
  padding: $innerPadding;
}
.swagger-ui .expand-methods svg,
.swagger-ui .expand-operation svg {
  inline-size: $iconSize;
  block-size: $iconSize;
}
.operation-tag-content > span {
  margin-block-end: $innerPadding;
  display: block;

  &:last-child {
    margin-block-end: 0;
  }
}
.swagger-ui .opblock .opblock-summary-method {
  border-radius: 16px;
  font-size: var(--font-size-body-s);
  font-family: $fontFamily;
  font-weight: var(--font-style-semi-bold);
  min-inline-size: 60px;
  padding-block: 4px 0;
}
.swagger-ui .opblock .opblock-summary-operation-id,
.swagger-ui .opblock .opblock-summary-path,
.swagger-ui .opblock .opblock-summary-path__deprecated,
.swagger-ui .opblock .opblock-summary-description {
  font-size: var(--font-size-body-s);
  font-family: $fontFamily;
  color: $customGray;
}
.swagger-ui .opblock .opblock-summary-path {
  font-weight: var(--font-style-semi-bold);
  padding-inline-start: 24px;
  color: $customGray;
}
.arrow {
  inline-size: $iconSize;
  block-size: $iconSize;
}
.swagger-ui .opblock .opblock-section-header {
  background-color: $backgroundGray;
}
.swagger-ui .opblock.opblock-get .tab-header .tab-item.active h4 span:after,
.swagger-ui .opblock .tab-header .tab-item.active h4 span:after {
  display: none;
}
.swagger-ui .opblock .opblock-section-header {
  min-block-size: 36px;
  padding: $innerPadding;
}
.swagger-ui .opblock .opblock-section-header h4,
.opblock-title.parameter__name {
  font-size: var(--font-size-body-s);
  font-family: $fontFamily;
  text-transform: uppercase;
  color: var(--color-text-neutral-strawberry);
  font-weight: var(--font-style-semi-bold);
}
// Apply Mercury button styles to SwaggerUI buttons
.swagger-ui .btn {
  // Use available Mercury variables
  font-size: var(--font-size-body-s);
  font-family: $fontFamily;
  font-weight: var(--font-style-regular);
  line-height: var(--line-height-tight, 1.3);
  color: $customGray;
  background-color: $backgroundGray;
  border: 1px solid $borderColor;
  border-radius: 4px;
  padding: 8px 12px;
  box-sizing: border-box;
}
.swagger-ui .opblock-description-wrapper,
.swagger-ui .opblock-external-docs-wrapper,
.swagger-ui .opblock-title_normal {
  padding: $innerPaddingLarger $innerPadding;
}
.swagger-ui .opblock-description-wrapper p,
.swagger-ui .opblock-external-docs-wrapper p,
.swagger-ui .opblock-title_normal p {
  font-size: var(--font-size-body-xs);
  font-family: $fontFamily;
  color: $customGray;
}
.swagger-ui .responses-inner,
.swagger-ui .table-container {
  padding: $innerPadding;
}
.swagger-ui .response-col_status,
.swagger-ui .response-col_description,
.swagger-ui .response-col_links,
.swagger-ui table thead tr th {
  font-size: var(--font-size-body-s);
  font-family: $fontFamily;
  color: var(--color-text-neutral-strawberry);
  font-weight: var(--font-style-semi-bold);
}
.swagger-ui .response-col_status:not(.col_header),
.swagger-ui .parameter__name {
  font-weight: var(--font-style-semi-bold);
  font-size: var(--font-size-body-xs);
}
.swagger-ui table thead tr td,
.swagger-ui table thead tr th {
  border-block-end: 1px solid $borderColor;
}
.swagger-ui .renderedMarkdown p {
  margin-block-start: 0;
  font-size: var(--font-size-body-xs);
  font-weight: var(--font-style-regular);
}
.swagger-ui .response-control-examples__title,
.swagger-ui .response-control-media-type__title {
  font-size: var(--font-size-body-s);
  font-weight: var(--font-style-semi-bold);
  margin-block-end: 8px;
}
.swagger-ui .response-control-media-type__accept-message {
  font-size: var(--font-size-body-xs);
  margin-block-start: 8px;
  display: inline-block;
  color: var(--color-text-success-default);
}
.swagger-ui .response-control-media-type--accept-controller select {
  border-color: var(--color-text-success-default);
}
.swagger-ui select {
  font-family: $fontFamily;
}
.swagger-ui .tab li {
  font-family: $fontFamily;
}
.swagger-ui .tab li {
  font-weight: var(--font-style-regular) !important;
}
.swagger-ui .opblock-body pre.microlight {
  border-radius: 0;
}
.swagger-ui .tab {
  margin-block-end: $innerPadding;
}
.swagger-ui input[type="email"],
.swagger-ui input[type="file"],
.swagger-ui input[type="password"],
.swagger-ui input[type="search"],
.swagger-ui input[type="text"],
.swagger-ui textarea {
  border-radius: 0;
  margin-block-start: 0;
  background-color: var(--color-accent-surface-surface);
}
.swagger-ui .model-box-control:focus,
.swagger-ui .models-control:focus,
.swagger-ui .opblock-summary-control:focus {
  outline: none;
}
.swagger-ui button,
.swagger-ui input,
.swagger-ui optgroup,
.swagger-ui select,
.swagger-ui textarea {
  font-family: $fontFamily;
  font-size: var(--font-size-body-s);
  color: $customGray !important;
}
.swagger-ui input[type="text"] {
  padding: 4px 12px;
}
.swagger-ui .models-control {
  font-size: var(--font-size-body-s);
  font-weight: var(--font-style-semi-bold);
  margin-block-end: 0;
  color: var(--color-text-neutral-strawberry);
}
.swagger-ui .models-control svg {
  inline-size: $iconSize;
  block-size: $iconSize;
}
.swagger-ui section.models {
  margin: 24px 0;
  border: 1px solid $borderColor;
  border-radius: 4px;
}
.swagger-ui section.models h4 {
  padding: 0;
}
.swagger-ui section.models.is-open h4 {
  border-bottom: 1px solid $borderColor;
}
.swagger-ui section.models h4 .models-control {
  padding: $innerPadding;
}
.swagger-ui section.models h4:hover {
  background-color: transparent;
}
.swagger-ui section.models .model-container {
  margin: $innerPadding;
  background: transparent;
  border: 1px solid $borderColor;
  border-radius: 4px;
}
.swagger-ui section.models .model-container:first-of-type {
  margin: $innerPadding;
}
.swagger-ui section.models .model-container:last-of-type {
  margin: 0 $innerPadding;
}
.swagger-ui section.models.is-open {
  padding: 0 0 $innerPadding;
}
.swagger-ui section.models .model-box {
  padding: $innerPadding;
}
.swagger-ui section.models .model-box .model-box {
  padding: 0;
}
.swagger-ui .model-title {
  font-family: $fontFamily;
  font-size: var(--font-size-body-s);
  font-weight: var(--font-style-semi-bold);
  color: var(--color-text-neutral-white);
}
.swagger-ui table.model tr.property-row td:first-child {
  color: var(--color-accent-primary-default);
}
.swagger-ui .parameter__name.required {
  color: var(--color-text-neutral-white);
}
.swagger-ui .parameter__type {
  color: $customGray;
}
.swagger-ui .parameter__in {
  color: var(--color-text-neutral-disabled);
}
.swagger-ui .parameter__in {
  color: $customGray;
}
.swagger-ui .parameter__name.required:after {
  color: var(--color-text-error-default);
}
.model-box {
  inline-size: 100%;
}
.model-box-control {
  line-height: 0;
  display: flex !important;
  align-items: center !important;
  inline-size: 100% !important;
}
.swagger-ui .model-toggle {
  inset-block-start: 0;
}
.swagger-ui .model-toggle:after {
  filter: brightness(0) saturate(100%) invert(60%) sepia(0%) saturate(0%)
    hue-rotate(0deg) brightness(0.8) contrast(1);
}

.swagger-ui .arrow,
.swagger-ui .arrow path,
.swagger-ui .expand-operation svg,
.swagger-ui .opblock-control-arrow svg,
.swagger-ui .opblock-summary-control svg,
.swagger-ui .btn.expand-methods svg,
.swagger-ui .btn.expand-operation svg {
  filter: brightness(0) saturate(100%) invert(60%) sepia(0%) saturate(0%)
    hue-rotate(0deg) brightness(0.8) contrast(1);
}

.swagger-ui .highlight-code > .microlight code,
.swagger-ui .model,
.swagger-ui .opblock-body pre.microlight {
  font-weight: var(--font-style-regular);
}

.swagger-ui .opblock.opblock-post .opblock-summary-method {
  background-color: var(--color-text-success-default);
}
.swagger-ui .opblock.opblock-get .opblock-summary-method {
  background: var(--color-accent-primary-default);
}
.swagger-ui .opblock.opblock-put .opblock-summary-method {
  background: var(--color-text-warning-default);
}
.swagger-ui .opblock.opblock-delete .opblock-summary-method {
  background: var(--color-text-error-default);
}
.swagger-ui select {
  color: $customGray;
}

.highlight-code pre,
pre.curl.microlight,
pre.microlight {
  background-color: $backgroundGray !important;
  border: 1px solid $borderColor;
  color: var(--color-text-neutral-strawberry) !important;
}
span[style*="color: rgb(211, 99, 99)"] {
  color: var(--color-text-error-default) !important;
}
span[style*="color: rgb(162, 252, 162)"] {
  color: var(--color-text-success-default) !important;
}
span[style*="color: rgb(252, 194, 140)"] {
  color: var(--color-text-warning-default) !important;
}

.swagger-ui .servers > label select,
.swagger-ui .content-type-wrapper select,
.swagger-ui .content-type {
  max-inline-size: 100%;
  min-inline-size: 130px;
  inline-size: 100%;
  border-radius: 4px;
  background-color: var(--color-accent-surface-surface);
  color: $customGray;
  font-weight: var(--font-style-regular);
  background-image: url("data:image/svg+xml;charset=utf-8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'><path fill='%23666' d='M6 8L2 4h8z'/></svg>");
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 12px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
